import { useMemo } from "react";

function genShadows(count, area) {
  const parts = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(Math.random() * area);
    const y = Math.floor(Math.random() * area);
    parts.push(`${x}px ${y}px #ffffff`);
  }
  return parts.join(", ");
}

function Starfield() {
  const layers = useMemo(
    () => ({
      small: genShadows(120, 2000),
      big: genShadows(40, 2000),
    }),
    []
  );

  return (
    <div className="starfield" aria-hidden="true" data-testid="bg-stars">
      <div className="glow-orb" />
      <div
        className="star-layer"
        style={{
          width: 1,
          height: 1,
          boxShadow: layers.small,
          animation: "drift 90s linear infinite, twinkle 5s ease-in-out infinite",
        }}
      />
      <div
        className="star-layer"
        style={{
          width: 2,
          height: 2,
          boxShadow: layers.big,
          animation: "drift 140s linear infinite, twinkle 7s ease-in-out infinite",
        }}
      />
    </div>
  );
}

export default function Background({ style }) {
  if (style === "gradient") return <div className="bg-gradient-layer" data-testid="bg-gradient" />;
  if (style === "plain") return <div className="bg-plain-layer" data-testid="bg-plain" />;
  return <Starfield />;
}
